import TokenConfirmationCheck from '@app/TwoFactor/TokenConfirmationCheck'

export default function install(Vue) {
  Vue.component(TokenConfirmationCheck.name, TokenConfirmationCheck)
}
